import dayjs from 'dayjs';

export const formatSSN = (SSN) => {
  return SSN?.length > 3 ? `XXX-XX-${SSN}` : `NA`;
};

export function formatPhoneNumber(phoneNumberString) {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    var intlCode = match[1] ? '+1 ' : '';
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return null;
}

export function formatCurrency(amount) {
  return new Intl.NumberFormat('en-us', {
    style: 'currency',
    currency: 'USD',
  }).format(Number.isNaN(amount) ? 0 : Number(amount));
}

export function formatPercentages(percentage) {
  const value = Number.isNaN(percentage) ? 0 : Number(percentage).toFixed(2);
  return `${value} %`;
}

export function formatStringToNumber(value) {
  return Number.isNaN(value) ? 0 : Number(value);
}

export const getUSNumberFormat = (value) => {
  return new Intl.NumberFormat('en-US').format(value);
};
export function formatDate(date, dateFormat = 'MM/DD/YYYY') {
  return dayjs(date).format(dateFormat);
}

export function getObjectURLFromPresigned(preSignedUrl) {
  const url = new URL(preSignedUrl);
  const objectUrl = `${url.origin}${url.pathname}`
  return objectUrl
}

export const renderYesNoResponse = (value) => {
  if (!value?.toString()?.length) return 'NA'
  return value === true ? 'Yes' : 'No'
};
